import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export type IRouteKeys =
  '/auth/login' |
  '/auth/password-recovery' |
  '/auth/password-recovery/request-new-password' |
  '/auth/password-recovery/validate-code' |
  '/auth/password-recovery/create-new-password' |
  '/modulos' |
  '/geo-veles' |
  '/geo-veles/extracoes' |
  '/geo-veles/extracoes/download' |
  '/dashboard/clientes/create' |
  '/dashboard/cadastro/cliente' |
  '/dashboard/cadastro/cliente/create' |
  '/dashboard/cadastro/cliente/edit' |
  '/dashboard/cadastro/perfil' |
  '/dashboard/cadastro/perfil/create' |
  '/dashboard/cadastro/perfil/edit' |
  '/dashboard/cadastro/usuario' |
  '/dashboard/trava/consumo' |
  '/dashboard/trava/consumo/cliente/novo' |
  '/dashboard/trava/consumo/cliente/atualizar' |
  '/dashboard/trava/consumo/usuario/novo' |
  '/dashboard/trava/consumo/usuario/atualizar' |
  '/dashboard/trava/consumo/perfil/novo' |
  '/dashboard/trava/consumo/perfil/atualizar' |
  '/dashboard/trava/ip-permitido' |
  '/dashboard/trava/ip-permitido/novo' |
  '/dashboard/trava/ip-permitido/atualizar'

interface INavigationState {
  activeRoute: IRouteKeys
}

const initialState: INavigationState = {
  activeRoute: '/modulos',
};

const navigationSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setActiveRoute(state, action: PayloadAction<{
      route: IRouteKeys,
      params?: any
    }>) {
      state.activeRoute = action.payload.route
    }
  },
});

export const { setActiveRoute } = navigationSlice.actions;
export const navigationReducer = navigationSlice.reducer;